import { render } from "./QBEExpandableEntity.vue?vue&type=template&id=1b66ef38&ts=true"
import script from "./QBEExpandableEntity.vue?vue&type=script&lang=ts"
export * from "./QBEExpandableEntity.vue?vue&type=script&lang=ts"

import "./QBEExpandableEntity.vue?vue&type=style&index=0&id=1b66ef38&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__